import { normalizeInferenceCapability } from "../../inference-capabilities.js";

export function llmCapabilityResolution(threadItem, capability) {
  const family = normalizeInferenceCapability(capability);
  return threadItem?.capability_resolution?.[family] || null;
}

export function llmCapabilitySendBlockReason(state, capability) {
  const resolution = llmCapabilityResolution(state?.thread, capability);
  if (!resolution || String(resolution.status || "").trim() !== "unavailable") {
    return "";
  }
  if (String(state?.composerRouteOverride || "").trim()) {
    return "";
  }
  return String(resolution.reason || "This capability is unavailable for the selected agent.").trim();
}
